import Proptypes from "prop-types";
import dayjs from "@shared/dayjs";

const isShort = (date) => (date || "").startsWith("0000");

const MilestoneDate = ({ milestoneDate = null }) => (
  <>
    {milestoneDate ? (
      <h5>{dayjs(milestoneDate).format(isShort(milestoneDate) ? "MM/DD" : "MM/DD/YYYY")}</h5>
    ) : (
      <span className="tw-text-gray-50">—</span>
    )}
  </>
);

MilestoneDate.propTypes = {
  milestoneDate: Proptypes.string,
};

export default MilestoneDate;
